export class TextResource {

    private textResources: Map<string, Map<string,string>>;     // <domain, <res-key, res-value>>

    constructor() {
        this.textResources = new Map();
    }

    public hasLangResources(lang: string) {
      return this.textResources.has(lang);
    }

    public addLangResources(lang: string, resources: Map<string, string>) {
        if (this.textResources.has(lang)) {
          this.textResources.delete(lang);
        }
        this.textResources.set(lang, resources);
    }
  
    public clearLangResources() {
      this.textResources.clear();
    }

    public findLangResources(lang: string): Map<string, string> | undefined {
      if (this.textResources.has(lang)) {
          return this.textResources.get(lang);
      }
      return undefined;
  }    
  

    public findLangResource(lang: string, key: string): string | null {
        if (this.textResources.has(lang)) {
            const langResources: Map<string, string> | undefined = this.textResources.get(lang);
            if (langResources) {
              if (langResources.has(key)) {
                return langResources.get(key) || null;
              }
            }
        }
        return null;
    }    
}
